module.exports = __webpack_public_path__ + "assets/images/04_thumb_e4d9e4e3dbdddb848fa6dafb759b3b9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/04_thumb.png
// module id = 124
// module chunks = 0